import React, { useState } from 'react';
import './DataImportConfirmation.css';

type OptionType = 'override' | 'append';

interface DataImportConfirmationSelectorProps {
  onSelect: (option: OptionType) => void;
}

const DataImportConfirmationSelector: React.FC<DataImportConfirmationSelectorProps> = ({ onSelect }) => {
  const [selectedOverrideAppend, setSelectedOverrideAppend] = useState<OptionType | null>(null);

  const handleSelect = (option: OptionType) => {
    setSelectedOverrideAppend(option);
    onSelect(option);
  };

  return (
    <div className="option-container">
      <div
        className={`option-box ${selectedOverrideAppend === 'override' ? 'selected' : ''}`}
        onClick={() => handleSelect('override')}
      >
        <div className="icon">
          {/* Custom SVG instead of emoji */}
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
            <g transform="translate(-872 -411)">
              <g>
                <g transform="translate(876.196 415.25)">
                  <path d="M25.461,31.5l-1.74-1.74,3.119-3.119H11.129a8.622,8.622,0,0,1-8.612-8.612V15.75H4.978v2.279a6.158,6.158,0,0,0,6.151,6.151H26.841l-3.119-3.119,1.74-1.74,6.09,6.09Zm3.63-15.75H26.631V13.471A6.158,6.158,0,0,0,20.479,7.32H4.768l3.119,3.119-1.74,1.74L.058,6.09,6.148,0l1.74,1.74L4.768,4.859H20.479a8.622,8.622,0,0,1,8.612,8.612Z" fill="#3e767a"/>
                </g>
                <rect width="40" height="40" transform="translate(872 411)" fill="none"/>
              </g>
            </g>
          </svg>
        </div>
        <div className="text">
          <h3>Overwrite
            <hr className="gold-line" />
          </h3>
          <p>Overwriting these files will permanently replace your existing content. We recommend downloading a backup of your current files before proceeding.</p>
        </div>
      </div>

      <div
        className={`option-box ${selectedOverrideAppend === 'append' ? 'selected' : ''}`}
        onClick={() => handleSelect('append')}
      >
        <div className="icon">
        {/* Custom SVG instead of emoji */}
          <svg xmlns="http://www.w3.org/2000/svg" width="31" height="27" viewBox="0 0 31 27">
            <path id="text-append" d="M5.556,10.188H34.2a1.184,1.184,0,1,0,0-2.368H5.556a1.184,1.184,0,0,0,0,2.368Zm0,8.216H34.2a1.184,1.184,0,1,0,0-2.368H5.556a1.184,1.184,0,0,0,0,2.368ZM8.11,31.355h4.523v1.631a1.244,1.244,0,0,0,2.154.972l4.169-3.4a1.2,1.2,0,0,0,0-1.913l-4.169-3.387a1.251,1.251,0,0,0-2.154.941v1.568H8.448a.469.469,0,0,1-.523-.533v-3.01c0-1.27-.646-2.054-1.769-2.054s-1.769.784-1.769,2.054V27.78A3.448,3.448,0,0,0,8.11,31.355ZM23.694,26.62H34.2a1.183,1.183,0,0,0,1.185-1.192A1.17,1.17,0,0,0,34.2,24.252H23.694a1.157,1.157,0,0,0-1.169,1.176A1.17,1.17,0,0,0,23.694,26.62Zm0,8.2H34.2a1.17,1.17,0,0,0,1.185-1.176A1.183,1.183,0,0,0,34.2,32.453H23.694a1.17,1.17,0,0,0-1.169,1.192A1.157,1.157,0,0,0,23.694,34.82Z" transform="translate(-4.387 -7.82)" fill="#3e767a" />
          </svg>

        </div>
        <div className="text">
          <h3>Append
            <hr className="gold-line" />
          </h3>
          <p>Your existing data will remain intact and the new content will be added at the end of the file. No existing information will be lost.</p>
        </div>
      </div>
    </div>
  );
};

export default DataImportConfirmationSelector;
